var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{staticClass:"main-gis-comparator"},[(!_vm.loaded)?_c('div',{staticClass:"loadingFalse"},[_c('div',{staticClass:"preloader"},[_c('span',{staticClass:"preloader-inner"},[_c('span',{staticClass:"preloader-inner-circle"})])])]):_c('div',{staticClass:"custom-table-container"},[_c('GisComparatorTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }